export default __webpack_public_path__ + "static/media/toast-close.79f0c0e3.svg";